<style lang='scss' scoped>
// 全局滚动条隐藏
::-webkit-scrollbar {
    display: none;
}

.index {
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
}

// 侧边栏样式优化
.sidebar {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    height: 100%;
    width: 500px;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    padding: 20px;
    padding-bottom: 0;
    overflow: auto;
    transition: transform 0.3s ease;

    &.collapsed {
        transform: translateX(-100%);
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 15px;
        border-bottom: 1px solid #eee;

        .logo {
            width: 180px;
            height: auto;
        }

        .gold-btn {
            background: linear-gradient(135deg, #ff9a44 0%, #fc5531 100%);
            color: white;
            padding: 8px 15px;
            border-radius: 5px;
            font-size: 14px;
            font-weight: bold;
            cursor: pointer;
            transition: all 0.3s;
            box-shadow: 0 2px 5px rgba(252, 85, 49, 0.3);

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 4px 8px rgba(252, 85, 49, 0.4);
            }
        }
    }
    .sectionAutoHeight {
        height: calc(100% - 100px);
        overflow: auto;
    }
    .section {
        margin-top: 15px;
        &:last-child {
            margin-bottom: 0;
        }

        .title {
            font-size: 18px;
            font-weight: 600;
            color: #333;
            margin-bottom: 15px;
            padding-left: 10px;
            position: relative;

            &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 3px;
                height: 16px;
                background: linear-gradient(to bottom, #ff9a44, #fc5531);
                border-radius: 3px;
            }
        }

        .items-container {
            // max-height: 65vh;
            overflow-y: auto;
            padding-right: 5px;

            .items-grid {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
                gap: 12px;

                .item {
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    border-radius: 6px;
                    font-size: 12px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.3s;
                    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);

                    &:hover {
                        transform: translateY(-3px);
                        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
                    }

                    .item-link {
                        display: block;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        text-decoration: none;
                        color: inherit;
                        padding: 5px;
                        box-sizing: border-box;
                    }
                }
            }
        }
    }
}

// 侧边栏切换按钮
.sidebar-toggle {
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 999;
    width: 40px;
    height: 40px;
    background: #ffffff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
    transition: all 0.3s;

    &:hover {
        transform: scale(1.1);
    }

    img {
        width: 24px;
        height: 24px;
        transition: transform 0.3s;
    }

    &.collapsed img {
        transform: rotate(180deg);
    }
}

// iframe样式
.content-iframe {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    border: none;
}

// 参考图抽屉样式（从左往右滑出）
.reference-drawer {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 500px;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    padding: 20px;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    pointer-events: none;

    &.open {
        transform: translateX(0);
        pointer-events: auto;
    }

    .dialog-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        border-bottom: 1px solid #eee;
        padding-bottom: 12px;
        color: #333;

        h3 {
            font-size: 20px;
            font-weight: 600;
            margin: 0;
        }

        .close-btn {
            font-size: 24px;
            cursor: pointer;
            transition: all 0.3s;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;

            &:hover {
                background-color: #f3f3f3;
                transform: rotate(90deg);
            }
        }
    }

    .dialog-content {
        flex: 1;
        overflow-y: auto;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
        padding-right: 5px;

        .img-item {
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            border-radius: 8px;
            background-color: #f8f8f8;
            transition: all 0.3s;
            position: relative;

            &:hover {
                transform: translateY(-3px);
                box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
            }

            .gold-img {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
                cursor: pointer;
                transition: transform 0.3s;

                &:hover {
                    transform: scale(1.05);
                }
            }

            &::after {
                content: "";
                position: absolute;
                inset: 0;
                border-radius: 8px;
                border: 1px solid #eee;
                pointer-events: none;
            }

            &.bg-item {
                background-color: #2b2b2b;
            }
        }
    }
}

@media (max-width: 768px) {
    .reference-drawer {
        width: 100%;
    }
}
</style>

<template>
    <div class="index">
        <!-- 侧边栏 -->
        <div class="sidebar" :class="{ collapsed: !sidebarVisible }" id="sidebar">
            <div class="header">
                <img src="../assets/toplogo.png" alt="Logo" class="logo">
                <div class="gold-btn" @click="switchVersion">
                    切换旧版
                </div>
                <div class="gold-btn" @click="openReferenceDrawer('gold')">
                    彩金图参考
                </div>
                <div class="gold-btn" @click="openReferenceDrawer('bg')">
                    底纹参考
                </div>
            </div>

            <div class="sectionAutoHeight">
                <div class="section">
                    <div class="title">{{ DataListobj.title }}</div>
                    <div class="items-container">
                        <div class="items-grid">
                            <div class="item" v-for="(item, itemIndex) in DataListobj.list" :key="itemIndex" :style="{ 'background': item.bgColor,  'color': item.color }" @click="opurl(item)">
                                <span class="item-link">{{ item.name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section">
                    <div class="title">{{ colorlistobj.title }}</div>
                    <div class="items-container">
                        <div class="items-grid">
                            <div class="item" v-for="(item, itemIndex) in colorlistobj.list" :key="itemIndex" :style="{ 'background': item.content['--apppage-bg2'],  'color': item.content['--btn-acrive-color'] }" @click="applyTheme(item)">
                                <span class="item-link">{{ item.name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section">
                    <div class="title">{{ baiban.title }}</div>
                    <div class="items-container">
                        <div class="items-grid">
                            <div class="item" v-for="(item, itemIndex) in baiban.list" :key="itemIndex" :style="{ 'background': item.bgColor,  'color': item.color }" @click="opurl(item)">
                                <span class="item-link">{{ item.name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 侧边栏切换按钮 -->
        <div class="sidebar-toggle" :class="{ collapsed: !sidebarVisible }" @click="sidebarVisible = !sidebarVisible">
            <img src="../assets/sq.png" alt="Toggle Sidebar">
        </div>

        <!-- 彩金图弹窗 -->
        <div class="reference-drawer" :class="{ open: currentReferenceDrawer === 'gold' }">
            <div class="dialog-header">
                <h3>彩金图参考列表</h3>
                <span class="close-btn" @click="closeReferenceDrawer">×</span>
            </div>
            <div class="dialog-content">
                <div class="img-item" v-for="(imgUrl, index) in jslist" :key="index" @click="applyJackpotImage(imgUrl)">
                    <el-image class="gold-img" :src="imgUrl">
                    </el-image>
                </div>
            </div>
        </div>

        <!-- 底纹参考弹窗 -->
        <div class="reference-drawer" :class="{ open: currentReferenceDrawer === 'bg' }">
            <div class="dialog-header">
                <h3>底纹参考列表</h3>
                <span class="close-btn" @click="closeReferenceDrawer">×</span>
            </div>
            <div class="dialog-content">
                <div class="img-item bg-item" v-for="(imgUrl, index) in bglist" :key="index" @click="applyBgImage(imgUrl)">
                    <el-image class="gold-img" :src="imgUrl">
                    </el-image>
                </div>
            </div>
        </div>

        <!-- 主内容iframe -->
        <iframe class="content-iframe" :src="iframeSrc" frameborder="0" ref="contentIframe" @load="onIframeLoad"></iframe>
    </div>
</template>

<script>
import { normalizeColorList } from './utils/zhutiColor'

/** PHP 后端地址，可通过 .env 设置 VUE_APP_API_BASE */
const API_BASE = 'https://ug-demo.com/backend/api/index.php'

export default {
    components: {},
    data() {
        return {
            sidebarVisible: true,
            currentReferenceDrawer: '',
            siteDataLoading: false,
            siteDataError: '',
            DataListobj: {
                title: '大厅版面参考站',
                list: []
            },
            colorlistobj: {
                title: '大厅色调参考站',
                list: []
            },
            baiban: {
                title: '白底版面参考站',
                list: []
            },
            iframeSrc: '',
            pendingColors: null,
            pendingJackpotImage: '',
            pendingBgImage: '',
            loginAccount: '',
            loginPassword: '',
            jslist: [],
            bglist: [],
        }
    },
    async created() {
        this.loginAccount = localStorage.getItem('local_login_account') || '';
        this.loginPassword = localStorage.getItem('local_login_password') || '';
        this.iframeSrc = localStorage.getItem('iframeSrc') || 'https://colorswitching1.ug-demo.com';
        await this.loadSiteBlocks()
    },
    mounted() {
        this.h5pagestylefun();
    },
    beforeDestroy() { },
    methods: {
        async loadSiteBlocks() {
            this.siteDataLoading = true
            this.siteDataError = ''
            try {
                const url = `${API_BASE}?action=get&block=all&_=${Date.now()}`
                const res = await fetch(url)
                const json = await res.json()
                if (!res.ok || !json.success) {
                    throw new Error((json && json.message) || `请求失败 (${res.status})`)
                }
                const blocks = json.data || {}
                if (blocks.hall) {
                    this.DataListobj = {
                        title: blocks.hall.title || '大厅版面参考站',
                        list: Array.isArray(blocks.hall.list) ? blocks.hall.list : [],
                    }
                }
                if (blocks.color) {
                    this.colorlistobj = {
                        title: blocks.color.title || '大厅色调参考站',
                        list: normalizeColorList(blocks.color.list),
                    }
                }
                if (blocks.white) {
                    this.baiban = {
                        title: blocks.white.title || '白底版面参考站',
                        list: Array.isArray(blocks.white.list) ? blocks.white.list : [],
                    }
                }
                if (blocks.jackpot) {
                    this.jslist = this.resolveImageList(blocks.jackpot.list)
                }
                if (blocks.texture) {
                    this.bglist = this.resolveImageList(blocks.texture.list)
                }
            } catch (e) {
                this.siteDataError = e.message || '加载参考站数据失败'
                console.error('[HomeView] loadSiteBlocks:', e)
                this.$message && this.$message.error(this.siteDataError)
            } finally {
                this.siteDataLoading = false
            }
        },
        resolveImageList(list) {
            if (!Array.isArray(list)) return []
            return list
                .map((item) => {
                    if (typeof item === 'string') return item
                    if (item && typeof item === 'object') {
                        return item.url || item.src || item.path || ''
                    }
                    return ''
                })
                .filter(Boolean)
        },
        openReferenceDrawer(type) {
            this.currentReferenceDrawer = type
        },
        closeReferenceDrawer() {
            this.currentReferenceDrawer = ''
        },
        switchVersion() {
            this.$router.push('/about')
        },
        toAbsoluteAssetUrl(url) {
            if (!url) return ''
            try {
                return new URL(url, window.location.origin).href
            } catch (e) {
                return url
            }
        },
        sendTheme(colors) {
            const win = this.$refs.contentIframe && this.$refs.contentIframe.contentWindow
            if (!win) return
            let origin = '*'
            try { origin = new URL(this.iframeSrc).origin } catch (e) { /* */ }
            try {
                if (colors && typeof win.setThemeColors === 'function') {
                    win.setThemeColors(colors)
                }
            } catch (e) { /* 跨域 */ }
            if (colors) {
                win.postMessage({ type: 'wgame:setThemeColors', colors }, origin)
            }

            const payload = {
                colors: colors || undefined,
                jackpotImage: this.pendingJackpotImage ? this.toAbsoluteAssetUrl(this.pendingJackpotImage) : undefined,
                bgImage: this.pendingBgImage ? this.toAbsoluteAssetUrl(this.pendingBgImage) : undefined,
            }
            console.log('[HomeView] send to iframe', {
                target: this.iframeSrc,
                origin,
                type: 'wgame:setThemeAssets',
                payload,
            })
            try {
                if (typeof win.setThemeAssets === 'function') {
                    win.setThemeAssets(payload)
                } else if (typeof win.setThemeConfig === 'function') {
                    win.setThemeConfig(payload)
                }
            } catch (e) { /* 跨域 */ }
            win.postMessage({ type: 'wgame:setThemeAssets', ...payload }, origin)
        },
        applyTheme(item) {
            if (!item || !item.content) return
            this.pendingColors = item.content
            this.sendTheme(item.content)
        },
        applyJackpotImage(imgUrl) {
            this.pendingJackpotImage = imgUrl || ''
            this.sendTheme(this.pendingColors)
        },
        applyBgImage(imgUrl) {
            this.pendingBgImage = imgUrl || ''
            this.sendTheme(this.pendingColors)
        },
        onIframeLoad() {
            if (!this.pendingColors && !this.pendingJackpotImage && !this.pendingBgImage) return
            setTimeout(() => this.sendTheme(this.pendingColors), 500)
        },
        opurl(item) {
            if (!item.link) return
            this.pendingColors = null
            this.pendingJackpotImage = ''
            this.pendingBgImage = ''
            const url = item.link.startsWith('http') ? item.link : `https://${item.link}`
            localStorage.setItem('iframeSrc', url)
            this.iframeSrc = url
        },
        h5pagestylefun() {
            this.$nextTick(() => {
                // 查看当前环境是不是手机端
                let sidebar = document.getElementById('sidebar');
                const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                if (isMobile) {
                    console.log('是');
                    sidebar.style.width = '100%';
                } else {
                    sidebar.style.width = '500px';
                }
            })
        },
    }
};
</script>